import DOMPurify from 'isomorphic-dompurify'

export const resanitiseHtml = cleanedContent => {
  cleanedContent
    .replace(/"\\&quot;/g, '\\"')
    .slice(1)
    .replace(/\\\&quot;"/g, '\\"')
    .slice(1)

  return cleanedContent
}
export const sanitiseString = html => {
  return typeof html === 'string' ? resanitiseHtml(DOMPurify.sanitize(html).toString()) : ''
}

export const isJsonObject = str => {
  try {
    const json = JSON.parse(str)
    return typeof json === 'object'
  } catch (e) {
    return false
  }
}

export const sanitiseHtml = jsonString => {
  if (!isJsonObject(jsonString)) return ''

  const jsonObject = JSON.parse(jsonString)

  if (jsonObject.pages.length > 0) {
    jsonObject.pages.forEach(page => {
      page.elements.forEach(stage => {
        if (stage.type === 'html') {
          stage.html = sanitiseString(stage.html)
        }
        if (stage?.elements && stage.elements.length > 0) {
          stage.elements.forEach(element => {
            if (element.type === 'html') {
              element.html = sanitiseString(element.html)
            }
          })
        }
      })
    })
    return JSON.stringify(jsonObject)
  }
  return JSON.stringify(jsonObject)
}
